/* eslint-disable react/prop-types */
import * as React from 'react';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import useSettings from '@hooks/useSettings';
import classes from './GridPanel.module.css';

const AssuranceItem = ({ children, title }) => (
  <div className={classes.assuranceItem}>
    <div className={classes.assuranceTitle}>{title}</div>
    {children}
  </div>
);

export const GridPanel = React.memo((props) => {
  const { rows = [], data, title } = props;
  const titlePadding = title ? 1 : 3;
  const { settingsInfo: { timeZone } = {} } = useSettings();
  return (
    <div className={classes.content}>
      {title ? (
        <div className={classes.title}>
          <section className={classes.titleText}>{title}</section>
        </div>
      ) : null}
      {rows.length ? rows.map((row, index) => (
        <Grid
          container
          spacing={2}
          paddingLeft={3}
          paddingTop={index === 0 ? titlePadding : 2}
          paddingBottom={index === 0 ? 0 : 3}
          // eslint-disable-next-line react/no-array-index-key
          key={`grid_${index}`}
        >
          {row.map((column) => (
            <Grid xs={6} md={4} padding={0} key={column.id}>
              <AssuranceItem title={column.label}>{column.format(data[column.id], '', timeZone)}</AssuranceItem>
            </Grid>
          ))}
        </Grid>
      )) : null}
    </div>
  );
});
